export default __webpack_public_path__ + "static/media/Xmark.3baecc40.svg";